import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ArchivQueryFilterConfig, IArchivQueryShapes, IArchivResponse } from 'fa-kt.types';

import { ArchivService } from '../service';

@Component({
  selector: 'fa-kt-archiv-filter',
  templateUrl: './archiv-filter.component.html',
  styleUrls: ['./archiv-filter.component.css'],
})
export class ArchivFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public ArchivFilterConfig: IFilterConfig<IArchivResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public archiv: ArchivService,
  ) {
    this.ArchivFilterConfig = ArchivQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.archiv.shapes$.subscribe((shapes: IArchivQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ArchivFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ArchivFilterConfig[index].selections = shapes;
  }
}
